import { combineReducers } from '@reduxjs/toolkit'
import callPerformanceFiltersSlice from './CallPerformance/Filters/slice'
import meetingPerformanceFiltersSlice from './MeetingPerformance/Filters/slice'
import leadReportFiltersSlice from './LeadReport/Filters/slice'

export const report = combineReducers({
  callPerformance: callPerformanceFiltersSlice,
  meetingPerformance: meetingPerformanceFiltersSlice,
  leadReport: leadReportFiltersSlice,
})
